// Whose Ctrl+V is it? The photo and document tabs listen for files pasted
// anywhere on the page, so they must leave alone pastes meant for a text
// field or for a dialog opened over them (the medical certificate editor,
// the upload dialog).

/** Inputs, text areas and rich-text editors keep their own paste. */
export function isTextField(target) {
  if (!target) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
}

/**
 * @param {Element} target - where the paste landed
 * @param {Element} root - the tab's own element
 * @returns {boolean} true when the paste is for this tab
 */
export function pasteBelongsHere(target, root) {
  if (isTextField(target)) return false;
  const modal =
    target && typeof target.closest === "function" ? target.closest(".modal") : null;
  // Inside a dialog: only the one the tab itself lives in.
  return !modal || !root || modal.contains(root);
}
